<div class="notification-container">
    <div (click)="goBack()">
        <img src="assets/images/fix-geoback-arrow-left-24.svg" alt="back-icon">
    </div>
    <span>
        Notification
    </span>
</div>